/**
 * Hard redirects (window.location) must include the CRA `homepage` segment.
 * The app is served at the domain root, so `PUBLIC_URL` is empty (package.json "homepage": "/").
 */
export function getLoginHref() {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return base ? `${base}/login` : "/login";
}
